export enum LocalStorageKeyEnum {
  /* if this exists, the user has seen the NextStepsLearnMore page*/
  HasViewedNextStepsLearnMore = 'nextStepsLearnMore',
  PostSurveyAlertDismissed = 'postSurveyAlertDismissed',
  /** What language is the activated (e.g. en, es) */
  Language = 'language',
  UserId = 'UserId',
}
